import React from 'react';

import { ADMIN_URL } from '../../../../../Admin/constants/constants';
import { ActionBtnType } from '../../../ActionMenu/ActionMenuItem/ActionMenuItem';

import BillLargeNormalSVG from 'Components/Admin/assets/BillLargeNormalSVG';
import DocumentLargeNormalSVG from 'Components/Admin/assets/DocumentLargeNormalSVG';
import PlusSmallSVG from 'Components/Admin/assets/PlusSmallSVG';
import DownloadSVG from 'Components/Admin/assets/DownloadSVG';
import DeleteSVG from 'Components/Admin/assets/DeleteSVG';

import ActionDropdown from '../../../ActionDropdown';

const ProjectActions = ({ id }) => {
  const handleDownloadPDF = () => {
    console.log('Download PDF...');
  };

  const menuItems = [
    [
      {
        type: ActionBtnType.BLOCK,
        title: 'Invoice',
        subTitle: 'Based on assignments for the last month.',
        icon: <BillLargeNormalSVG />,
        path: `/${ADMIN_URL}/invoices/${id}`,
      }, {
      type: ActionBtnType.BLOCK,
      title: 'Blank order',
      subTitle: 'Create new blank order for this project.',
      icon: <DocumentLargeNormalSVG />,
      path: `/${ADMIN_URL}/orders/${id}`,
    },
    ], [
      {
        type: ActionBtnType.LINK,
        title: 'Assign employee',
        icon: <PlusSmallSVG />,
      }, {
        type: ActionBtnType.LINK,
        title: 'Download PDF',
        icon: <DownloadSVG />,
        action: handleDownloadPDF,
      },
    ],
    [
      {
        type: ActionBtnType.LINK_DANGER,
        title: 'Delete project',
        icon: <DeleteSVG />,
        path: `/${ADMIN_URL}/projects/${id}/delete`,
      },
    ],
  ];

  return (
    <ActionDropdown menuItems={menuItems} title="Generation" id={id}/>
  );
};

export default ProjectActions;
